module.exports = __webpack_public_path__ + "static/img/demo-img.78f18a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/demo-img.jpg
// module id = 74
// module chunks = 0